const SessionKeys = {
  ACTIVE_DOMAIN: "activeDomain",
  ARTICLE_ID: "articleId",
  AUTHORIZATION_KEY: "Authorization"
}
export default SessionKeys;
